export default "__VITE_ASSET__B6Y2jEvW__"